import React from 'react'

const Admin = () => {
    return (
        <div className='container'>
            <div class="col-12 col-lg-9">



<h1 aria-label="What is Database Administration and Is It the Career Path for You?">
    What is Database Administration and Is It the Career Path for You?
</h1>











<div id="XB">
    <div class="clear"></div>
    <div class="contentCopy">
       
        <p>Databases are common to most modern businesses. There isn't anything on the Internet without a database;
            anything that requires e-commerce has a database. Technology is always growing and companies in all
            industries around the globe need database administrators (DBAs) to make sure all information stored on
            their computers is secure and only available to authorized users.</p>
        <p>Armed with the knowledge and experience to write and install computer programs and debug software issues,
            database administrators are the people who help companies of any size set up, maintain, and secure large
            volumes of information.</p>
        <p>Imagine what you can do by gaining real-world, hands-on experience in database administration. You can
            develop the skills and knowledge you'll need to create a fulfilling career in this growing high-tech
            field of developing and managing databases, with a special focus on the popular and top-rated Oracle
            database solutions.</p>
        <h2>What Is Database Administration?</h2>
        <p>Database administration enables you to help companies create new or update existing databases based on
            their internal data collection needs. A database administrator position offers you a chance to be
            creative and solve problems in database development and testing by writing software scripts, testing
            database functionality and keeping company data clean and secure.</p>
        <p>In a TechRepublic article titled, "What does a DBA do all day?" <strong>Bob Watkins</strong> summarized
            the DBA responsibilities clearly. "It's been said that the database administrator (DBA) has three basic
            tasks. In decreasing order of importance, they are: <strong>protect the data, protect the data, and
                protect the data</strong>."</p>
        <p>As a DBA, your first responsibility is always going to be to maintain the integrity of the company's data
            - because even if a database is fast and accessible, it's useless if the data being accessed is
            distorted.</p>
        <p>In an entry-level role, you'll work closely with managers to learn about the type of data to collect, the
            form the data should be stored in, and how to make the data available for exporting into reports, for
            example. You'll learn the ways to verify that the database's integrity isn't compromised and how to keep
            the data secure. When starting out, you'll receive guidance on implementing data models and database
            designs by following policies and procedures and be able to grow your expertise through daily
            experience.</p>
        <p>As a DBA, you'll also focus on monitoring and maintaining a high level of system performance. Database
            administrators are responsible for performing regular system backups so no data is lost during a power
            outage or other type of disaster. You'll also work to ensure that the data being captured is reliable,
            error-free and available at any time.</p>
        <p>Online system security is important, particularly when it comes to companies that capture personal and
            financial customer information, which is almost every e-commerce business. In your position as a
            database administrator, you'll have a chance to develop applicable security measures when designing new,
            or helping to update existing, databases.</p>
        <h2><span style={{fontSize: '1.6rem'}}>Is Database Administration Right for You?</span></h2>
        <p>When it comes to computer technology, do you love the idea of maintaining and being responsible for large
            amounts of data? Do you think it's fun to develop procedures for capturing data? Is it enticing to think
            about building a database to maintain various types of information for a company?</p>
        <p>Have you already taken some programming classes? You may have already dabbled with data analytics and
            want to learn more about data manipulation through database administration.</p>
        <p>This was true for <strong>Angelic Tofteroo '16</strong>. "(Database administration) was a small part of
            my previous position, but an area of implementation that I enjoyed the most. I excelled in this area and
            truly enjoyed the complex architecture of database structures."</p>
        <p>The more Tofteroo learned through the online database
                administration&nbsp;program, the more she found to be intrigued about. "The more solutions I
            learned were available the more I was interested in exploring their usage," she said.</p>
        <p>With her information technology
                degree&nbsp;with a concentration in database administration, Tofteroo found a job that uses her
            skills and is helping her to learn new ones. She said, "I have an amazing job as an application
            consultant with an innovative software company. The best part of my job is that I am able to perform
            various IT tasks including database management, coding, HTML, and project management."</p>
        <p>If you love the idea of building or administering system databases for an organization, and have the
            desire to learn more about computer software, focusing on database administration will give you a chance
            discover what you enjoy most.</p>
        <p>If you're already in a role that allows you to play with technology and learn about software programming
            and databases, obtaining advanced education and hands-on experience can give you the boost you need to
            help you seek advancement in your current company or help you transition into a new company.</p>
        <p>It's sometimes true that the more you learn, the more you'll find you want to learn. Once you start
            learning more about databases, you can expand your horizons with additional classes that interest you.
            "Definitely explore all of the options available," Tofteroo said. "Take additional IT classes as
            electives. The deeper your understanding, the more enjoyable the classes will be."</p>
        <p>As a DBA, your ever-expanding knowledge will help you troubleshoot issues as they arise by learning how
            to identify the problem and learning how to correct it without losing data. As a DBA, you won't be bored
            if you enjoy solving problems or puzzles particularly in regard to learning how data is collected,
            processed, reported and maintained.</p>
        <h2>What Does a Database Administrator Do?</h2>
        <p>Technological advancements and the ability to store mind-boggling amounts of data on drives and in the
            cloud to run e-commerce is driving the increased need for database administrators. Particular
            specialties that use database administration skills include System DBA and Application DBA.</p>
        <ul>
            <li><strong>System DBAs</strong>, also referred to as traditional or general-purpose DBAs, generally
                focus on any physical and technical aspects of database management that keep systems running
                smoothly, efficiently and error-free. The main responsibility is to make sure data is secure and to
                avoid data loss. Other tasks can include updating permissions and installing upgrades and patches to
                fix software program bugs. System DBAs can be responsible for various applications on different
                systems, merging old databases into new databases and making and testing modifications to the
                database structures when needed.</li>
            <li><strong>Application DBAs</strong> are experienced system DBAs with specialized skills for a
                particular application or set of applications, such as database design, functional expertise or
                particular server knowledge, such as Oracle, or a particular suite of Oracle applications.</li>
            <li><strong>An Oracle application DBA</strong> requires special skills in business administration as
                well as Oracle application server architectures. If this is your goal, you'll also need to
                understand the particular nuances of Oracle database design, the internal workings of the Oracle
                application server and how to tune applications. Then to specialize, you'll want to have the
                functional expertise pertaining to a particular industry or type of business.</li>
        </ul>
        <h2>Career Opportunities in Database Administration</h2>
        <p>Healthcare organizations require the storage and management of digital records, driven by federal
            regulations requiring secure storage of patient records and information. Health information analyst
            positions are expected to grow 13% by 2026, according to BLS. A health information management
                degree &nbsp;can prepare you to work as a database administrator, clinical information specialist
            or health information analyst in a variety of settings, including:</p>
        <ul>
            <li>Hospitals</li>
            <li>Physician offices</li>
            <li>Long-term care facilities</li>
            <li>Ambulatory care facilities</li>
            <li>Insurance companies</li>
            <li>Pharmaceutical companies</li>
            <li>Medical manufacturers</li>
            <li>Behavioral health organizations</li>
            <li>Governmental healthcare agencies</li>
            <li>Healthcare-related organizations</li>
        </ul>
        <p>Other jobs that use database administration skills include IT Consultant, IT Project Manager, Application
            Consultant, and Network Administrator, to name a few.</p>
        <p><strong>Charles Fulgham's</strong> degree in database administration took him all the way to the FBI.
            Because of that he can't say much about what he does there beyond "database-related work on behalf of
            the Department of Justice." But he said studying online immediately paid dividends at work. He
            remembered one meeting at work focused on issues on the office's computer network. He'd learned in a
            course he was taking at the time about a tool called WireShark and suggested using it to read the
            network's data packets and was able to find and solve the networking problem.</p>
        <p>"That more than anything is really valuable stuff," Fulgham said. "I know that i was able to take what I
            learned a pretty much apply it immediately on the job. I'm really glad I did it."</p>
        <p>You may also choose to continue your education by pursuing an Oracle certification, advance through a master's degree in IT, or even
            transition into a related field, such as cyber security. You'll have options to choose from and new
            interests to pursue.</p>
        </div>
</div>




</div>
        </div>
    )
}

export default Admin
